import axios from "axios";

let urls = process.env.urls;

const get_urls = () => {
  const host = window.location.host.split(":")[0];
  if (host === "billing-web.services.orcicare.com") {
    return "https://provider.services.orcicare.com/";
  }
  // if (host === "billing-web-test.services.orcicare.com") {
  return "https://provider-test.services.orcicare.com/";
  // }
  // return `https://${[host, 5000].join(":")}/`;
};

const url = urls || get_urls();

const instance = axios.create({
  baseURL: url,
});

export default instance;
